import {PureComponent} from 'react'
import {Link} from 'react-router-dom'
import CheckSquare from 'react-feather/dist/icons/check-square'
import FileText from 'react-feather/dist/icons/file-text.js'
import Search from 'react-feather/dist/icons/search.js'
import UserCheck from 'react-feather/dist/icons/user-check.js'

import {generate} from '../../routes.js'

import LinkAs from "../LinkAs/LinkAs.jsx"

import './HowToGetMissions.scss'

export default class HowToGetMissions extends PureComponent {
  render() {
    return <section id="how-to-get-missions" className="container text-center py-5">
      <h2 className="mb-4">Comment obtenir une mission avec Twineeds ?</h2>
      <div className="row justify-content-center mb-4">
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <FileText/>
          <h3>Inscrivez-vous</h3>
          <p>Indiquez vos <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'la-disponibilite-element-clef-du-consultant'}})}>disponibilités</Link></strong>, préférences de mission et votre <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'la-mobilite-facteur-de-reussite-du-consultant'}})} target="_blank" rel="noopener noreferrer">mobilité</Link></strong>.</p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <UserCheck/>
          <h3>Rencontrez-nous</h3>
          <p>Rencontrez en visio l'un de nos managers pour mieux <strong>comprendre votre profil, vos contraintes et vos attentes</strong>.</p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <CheckSquare/>
          <h3>Finalisez votre inscription</h3>
          <p>Complétez votre dossier de compétences afin d'accéder aux différentes missions.</p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column p-2 p-md-3">
          <Search/>
          <h3>On vous recontacte !</h3>
          <p>Lorsqu'une mission correspond à votre profil, Twineeds vous recontacte par téléphone ou SMS.</p>
        </div>
      </div>
      <LinkAs
        className="btn btn-primary"
        notConnected={generate({name: 'register-freelance'})}
        freelance={generate({name: 'freelance-dashboard'})}
      >
        S'inscrire
      </LinkAs>
    </section>
  }
}
